<app-device-detail-summary
  [historyFormGroup]="historyFormGroup"
  [latestDeviceInfo]="latestDeviceInfo"
  [deviceInfoExportHistory]="deviceInfoExportHistory"
  [deviceSetting]="deviceSetting"
  [deviceName]="deviceName"
  [tenantCreatedAt]="tenantCreatedAt"
  [batteryPercentage]="batteryPercentage"
  [historyBatteryPercentage]="historyBatteryPercentage"
  [historyBatteryReportedAt]="historyBatteryReportedAt"
  [batteryLow]="batteryLow"
  [lastCommunicationAt]="lastCommunicationAt"
  [fmdOn]="fmdOn"
  [fmdEnabled]="fmdEnabled"
  (historyFiltered)="findbyIdHistory()"
  (exportButtonClicked)="findbyIdExportHistory()"
  (sensingTypeChanged)="sensingTypeChanged($event)"
>
</app-device-detail-summary>

<app-device-detail-chart
  [historyFormGroup]="historyFormGroup"
  [deviceSensorHistoryList]="deviceLocationList"
  [batteryHistoryList]="batteryHistoryList"
  [locationHistoryList]="batteryLocationList"
  [sensorThresholdInfo]="deviceSensorThresholdInfo"
  (chartPointsChanged)="onSelectedChartPoints($event)"
  [sensingType]="selectedSensingType"
></app-device-detail-chart>

<app-device-detail-map
  [locationList]="deviceLocationList"
  [batteryLocationList]="batteryLocationList"
  [deviceName]="deviceName"
  [sensingType]="selectedSensingType"
  [chartPoints]="selectedChartPoints"
></app-device-detail-map>
